<div class="course-details-breadcrumb-1 bg_image rts-section-gap">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="single-course-left-align-wrapper">
          <div class="meta-area">
            <a class="text-white" [routerLink]="['/']">Início</a>
            <i class="fa-solid fa-chevron-right text-white"></i>
            <a class="active text-white" [routerLink]="['/a-facint']"
              >A Facint</a
            >
          </div>
          <h1 class="title text-white">Conheça a Facint</h1>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="about-area-start style-two mb--200">
  <div class="container">
    <p class="paragraph">
      A Faculdade Facint é uma instituição de ensino superior comprometida com a
      formação integral dos seus estudantes, por meio de uma educação de
      qualidade, ética e inovadora. Nossa missão é formar profissionais
      preparados para os desafios do mundo contemporâneo, capazes de transformar
      realidades e contribuir para o desenvolvimento social, científico e
      tecnológico do país.
    </p>

    <p class="paragraph">
      Com uma proposta pedagógica alinhada às exigências do mercado de trabalho
      e às transformações da sociedade, a Facint valoriza a prática
      profissional, a pesquisa aplicada e a formação humanista. Aqui, o
      conhecimento é acessível, dinâmico e voltado à construção de trajetórias
      de sucesso.
    </p>

    <p class="paragraph">
      Fundada em 08 de abril de 2022 com vocação inicial para a área de
      tecnologia, a instituição passou por um importante processo de expansão em
      2025, quando adotou oficialmente o nome Faculdade Facint. Esse movimento
      marcou o início de um novo ciclo, com a ampliação da oferta de cursos e a
      unificação com outra instituição de ensino em Maringá–PR. A partir dessa
      integração, a sede da Facint passou a ofertar também o curso de Direito,
      ampliando sua presença no cenário acadêmico regional.
    </p>

    <p class="paragraph">
      Ainda em 2025, a Faculdade Facint aguarda a autorização de funcionamento
      dos cursos de Biomedicina, Psicologia e Odontologia, para serem ofertados
      na sede em Maringá-PR a partir de 2026.
    </p>

    <p class="paragraph">
      Como parte da sua estratégia de crescimento, o grupo educacional também
      incorporou a Faculdade Falcão, em Goiânia–GO, que passa a ser denominada
      Faculdade Facint Goiânia, expandindo o portfólio de cursos e a presença
      institucional da Facint no território nacional.
    </p>

    <p class="paragraph">
      Além da atuação no ensino superior, o grupo Facint conta com a
      <strong>Facintec – Escola Técnica</strong>, localizada em Campo Grande–MS,
      onde são ofertados cursos técnicos de nível médio e a Educação de Jovens e
      Adultos (EJA), reafirmando o compromisso com a formação profissional desde
      a base. Em processo de implantação, a Escola Facint, voltada à educação
      básica, ampliará a atuação do grupo em Maringá, proporcionando uma jornada
      educacional completa. O grupo também mantém a Atena Idiomas, escola
      especializada em ensino de línguas, complementando a formação dos
      estudantes com competências linguísticas essenciais ao mundo globalizado.
    </p>
  </div>
</div>
